import { RX0001 } from "../rxTypeCode";

export const SET_SOURCECURRENCY = "SET_SOURCECURRENCY" + RX0001;
export const SET_TARGETCURRENCY = "SET_TARGETCURRENCY" + RX0001;
export const SET_ORDERIDS = "SET_ORDERIDS" + RX0001;
export const SET_ORDERS = "SET_ORDERS" + RX0001;
export const SET_TIME = "SET_TIME" + RX0001;
export const SET_TOTALSOURCEAMOUNT = "SET_TOTALSOURCEAMOUNT" + RX0001;
export const SET_TOTALCONVERTEDAMOUNT = "SET_TOTALCONVERTEDAMOUNT" + RX0001;
export const SET_TOTALTARGETAMOUNT = "SET_TOTALTARGETAMOUNT" + RX0001;
export const SET_TOTALREMITFEES = "SET_TOTALREMITFEES" + RX0001;
export const SET_REMAININGTIME = "SET_REMAININGTIME" + RX0001;
export const SET_MODALVISIBLE = "SET_MODALVISIBLE" + RX0001;

export const LOCKEXCHANGERATE_REQUEST = "LOCKEXCHANGERATE_REQUEST" + RX0001;
export const LOCKEXCHANGERATE_SUCCESS = "LOCKEXCHANGERATE_SUCCESS" + RX0001;
export const LOCKEXCHANGERATE_FAILURE = "LOCKEXCHANGERATE_FAILURE" + RX0001;

export const UPDATEEXCHANGERATE_REQUEST = "UPDATEEXCHANGERATE_REQUEST" + RX0001;
export const UPDATEEXCHANGERATE_SUCCESS = "UPDATEEXCHANGERATE_SUCCESS" + RX0001;
export const UPDATEEXCHANGERATE_FAILURE = "UPDATEEXCHANGERATE_FAILURE" + RX0001;
export const UPDATEEXCHANGERATE_CLEAN_ERROR = "UPDATEEXCHANGERATE_CLEAN_ERROR" + RX0001;
export const UPDATEEXCHANGERATE_CLEAN_SUCCESS = "UPDATEEXCHANGERATE_CLEAN_SUCCESS" + RX0001;
